import { useEnsureCurrentUser } from '@cosuno/authentication-frontend';
import type { ModalStateData } from '@cosuno/modal-frontend';
import { Modal, ModalWindow } from '@cosuno/modal-frontend';
import type { FC } from 'react';

import type { PRICING_PLAN } from '~/__gql__/graphql';
import useAnalytics from '~/shared/hooks/useAnalytics';
import useTranslation from '~/shared/hooks/useTranslation';

import PricingPlansContent from '../PricingPlansContent';
import { PricingModalAddonsTitle, PricingPlansModalContent } from '../Styles';

interface InternalDocumentManagementUpsellModalProps extends ModalStateData {
  highlightedPlan: PRICING_PLAN | null;
}

export const PricingPlanModal: FC<InternalDocumentManagementUpsellModalProps> = ({
  highlightedPlan,
  ...modalState
}) => {
  const currentUser = useEnsureCurrentUser();
  const { t } = useTranslation('company');
  const { trackEvent } = useAnalytics();

  return (
    <Modal
      {...modalState}
      name="pricingPlanModal"
      isTopLevelModal
      maxWidth={1270}
      renderContent={() => (
        <>
          <ModalWindow.Header>{t('pricingPlans.title')}</ModalWindow.Header>
          <PricingPlansModalContent>
            <PricingPlansContent
              highlightedPlan={highlightedPlan}
              onRequestItem={(item) => {
                trackEvent('upsellPlansTierInfo', { tier: item, role: currentUser.type });
              }}
              renderAddOnsHeading={() => (
                <PricingModalAddonsTitle>{t('pricingPlans.addOnsTitle')}</PricingModalAddonsTitle>
              )}
            />
          </PricingPlansModalContent>
        </>
      )}
    />
  );
};
